import { FC } from 'react';
import { ImageList, ImageListItem, Stack } from '@mui/material';
import { TDocumentData, TDocumentInfo } from '../../models';
import { FileContent } from '../FileContent';
import { DocumentImgWrapper, Label } from './styles';

export const DocumentImgCard: FC<{
  fileItems: TDocumentData[];
  requestId: string;
  document: TDocumentInfo;
}> = ({ fileItems, requestId, document }) => {
  return (
    <ImageList cols={1}>
      {fileItems.map((dataItem) => (
        <ImageListItem key={dataItem.dataId} sx={{ marginBottom: '24px' }}>
          <DocumentImgWrapper
            flexDirection='row'
            alignItems='flex-start'
            gap={2}
          >
            <FileContent
              requestId={requestId}
              documentId={document.documentId}
              fileId={dataItem.dataId}
              dataLink={dataItem.dataLink}
              fileInfo={dataItem.fileInfo}
            />
            <Stack
              direction='column'
              justifyContent='center'
              alignItems='flex-start'
              gap='8px'
              sx={{ flex: 1, minWidth: 0 }}
            >
              <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
                sx={{ width: '100%' }}
              >
                <Label>ID {dataItem.id}</Label>
              </Stack>
            </Stack>
          </DocumentImgWrapper>
        </ImageListItem>
      ))}
    </ImageList>
  );
};
